import { Col, Collapse, Divider, Row } from 'antd'
import React from 'react'

function Quiz({ data }) {
    return <ul>
        {data.answers.map((item, index) => <li key={index} style={{ color: data.correct_answers.includes(index) ? "green" : "" }}>
            {item}
        </li>)}
    </ul>
}

export default function QuizList({ quizzes, essays }) {
    return <Row gutter={10}>
        <Col span={24} lg={12}>
            <Divider>
                Trắc nghiệm
            </Divider>
            <Collapse items={quizzes.map(item => ({
                key: item.id,
                label: <>{item.question} ({item.correct_answers.length === 1 ? "single choice" : "multiple choice"})</>,
                children: <Quiz data={item} />
            }))} />
        </Col>
        <Col span={24} lg={12}>
            <Divider>
                Tự luận
            </Divider>
            <Collapse items={essays.map(item => ({
                key: item.id,
                label: item.question,
                children: <div><b>Gợi ý:</b> {item.hint}</div>
            }))} />
        </Col>
    </Row>
}
